import Trophy from "@/assets/icons-v2/trophy.svg";
import CustomSvg from "@/components/common/custom-svg/custom-svg";
import Email from "@/assets/icons-v2/email.svg";
import Location from "@/assets/icons-v2/location.svg";
import Calendar from "@/assets/icons-v2/calendar.png";
import Profile from "@/assets/icons-v2/profile.svg";
import Logout from "@/assets/icons-v2/signout.svg";
import Share from "@/assets/icons-v2/share.svg";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineGroups, MdOutlineHouse } from "react-icons/md";
import { FaPuzzlePiece } from "react-icons/fa";
// import Help from "@/assets/icons-v2/help.svg";
import { ReactNode } from "react";

const iconSize = { height: 25, width: 25 };

export interface MenuItem {
    label: string;
    url: string;
    icon: ReactNode;
    isRegistered?: boolean;
    hidden?: boolean;
}

export const SIDEMENU_ITEMS: MenuItem[] = [
    {
        label: "My Profile",
        url: "",
        icon: <CustomSvg src={Profile} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
    {
        label: "Sign In",
        url: "",
        icon: <CustomSvg src={Profile} size={iconSize} />,
        isRegistered: false,
        hidden: true,
    },
    {
        label: "Switch Location",
        url: "",
        icon: <CustomSvg src={Location} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
    {
        label: "Home",
        url: "/",
        icon: <AiOutlineHome size={25} />,
    },
    /** @deprecated Social mode retired; hidden, routes 301 → / */
    {
        label: "Social",
        url: "/social",
        icon: <MdOutlineGroups size={25} />,
        hidden: true,
    },
    /** @deprecated Feed is now at /; /puzzle aliases to / */
    {
        label: "Puzzle",
        url: "/puzzle",
        icon: <FaPuzzlePiece size={25} />,
        hidden: true,
    },
    /** @deprecated Classic retired; hidden, routes 301 → / */
    {
        label: "Classic",
        url: "/classic",
        icon: <MdOutlineHouse size={25} />,
        hidden: true,
    },
    {
        label: "Leaderboard & Stats",
        url: `/leaderboard`,
        icon: <CustomSvg src={Trophy} size={iconSize} />,
    },
    {
        label: "Invite a friend",
        url: ``,
        icon: <CustomSvg src={Share} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Contact Us",
        url: `/contact`,
        icon: <CustomSvg src={Email} size={iconSize} />,
    },
    /*
    {
        label: "FAQ",
        url: "/faq",
        icon: <CustomSvg src={Help} size={iconSize} />,
    },
    {
        label: "FAQ",
        url: "/classic/faq",
        icon: <CustomSvg src={Help} size={iconSize} />,
        hidden: true,
    },
    */
    {
        label: "Sign Out",
        url: "",
        icon: <CustomSvg src={Logout} size={iconSize} />,
        isRegistered: true,
        hidden: true,
    },
];

export const LIVE_VARIANT_SIDEMENU_ITEMS: MenuItem[] = [
    {
        label: "Back to Daily Game",
        url: "",
        icon: <CustomSvg src={Trophy} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Choose Area",
        url: "",
        icon: <CustomSvg src={Location} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Play archives",
        url: "",
        icon: <CustomSvg src={Calendar} size={iconSize} />,
        hidden: true,
    },
    {
        label: "Contact Us",
        url: `/contact`,
        icon: <CustomSvg src={Email} size={iconSize} />,
    },
    {
        label: "Leaderboard & Stats",
        url: "/leaderboard",
        icon: <CustomSvg src={Trophy} size={iconSize} />,
    },
];
